import contactSectionImage from "./../assets/contact-section-image.png";
import B2BContactLeadForm from "./B2BContactLeadForm";
import { Link } from "react-router-dom";

const ContactSection = ({
  content = "Interested in bringing Artificial Intelligence to your brand?",
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
      <div className="order-1 md:order-2 md:justify-self-end w-full">
        <div className="w-full h-[440px] sm:h-[700px] rounded-[10px] overflow-hidden relative ">
            <div className="absolute inset-0 flex items-center justify-center bg-[#F7F7F7] mb-[60px]">
              <div className="h-[90%] rounded-[8px] overflow-hidden mt-[36px] md:mt-[64px]">
                <img
                  src={contactSectionImage}
                  alt="Eveness solutions hero"
                  className="w-full h-full object-contain"
                  loading="lazy"
                />
              </div>
            </div>
        </div>
      </div>

      <div className="order-2 md:order-1 max-w-[520px]">
        <h2 className="text-[32px] leading-[34px] md:text-[44px] md:leading-[52px] font-normal text-black tracking-[-1.44px]">
          {content}
        </h2>

        <p className="mt-5 max-w-[420px] font-normal text-[13px] leading-[23.4px] tracking-[0.17px] align-middle text-[#1A1A1A]">
          To unlock your own branded GPT, advanced fit &amp; style solutions,
          and a recommendation algorithm that reorders your collection pages to
          reduce returns, please{" "}
          <Link
            to="/get-started"
            className="text-[#1A1A1A] hover:text-black font-normal text-[13px] leading-[23.4px] tracking-[0.17px] align-middle underline decoration-solid"
          >
            get in touch.
          </Link>
        </p>

        <B2BContactLeadForm />
      </div>
    </div>
  );
};

export default ContactSection;
